import { createContext } from 'react';

import { Volume } from '@totem/components/devices/volumes/types';

interface Context {
  deviceId: string;
  loading: boolean;
  data: Volume[];
  action: string;
  actionItem: Volume;
  onAction?: (action: string, item: Volume) => void;
}

export default createContext<Context>({
  deviceId: '',
  loading: false,
  data: null,
  action: '',
  actionItem: null,
  onAction: () => {},
});
